
    import I18n from 'i18nObj';
    
      import 'translations/instructure_misc_plugins';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('instructure_misc_plugins');
  